export default __webpack_public_path__ + "static/media/arrow-down-purple.52b06b3a.svg";